import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomainChooserComponent } from './domain-chooser.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EmailUII18nModule } from '../../src/lib/i18n/email-ui-i18n.module';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { MatRadioModule } from '@angular/material/radio';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [DomainChooserComponent],
  exports: [DomainChooserComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    EmailUII18nModule,
    ReactiveFormsModule,
    GalaxyFormFieldModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    GalaxyPipesModule,
    GalaxyAlertModule,
  ],
})
export class DomainChooserModule {}
